<template>
  <div :style="style">
    <el-container class="container">
      <el-header style="height:auto; max-height:945px" class="head">
        <Header
          v-if="
            ![
              'knowledge-base',
              'expert-base',
              'members-home',
              'search-result',
              'cfbb',
              'expertcenter'
            ].includes($route.name)
          "
        ></Header>
        <BaseHeader
          v-if="
            [
              'knowledge-base',
              'expert-base',
              'members-home',
              'expertcenter'
            ].includes($route.name)
          "
        ></BaseHeader>
        <div class="nav-wrap" v-if="!['cfbb'].includes($route.name)">
          <div class="nav-back"></div>
          <nav-menu></nav-menu>
          <div class="nav-back"></div>
        </div>
      </el-header>
      <el-main>
        <keep-alive :include="getKeepAliveList">
          <router-view />
        </keep-alive>
      </el-main>
      <el-footer>
        <partner></partner>
        <friendly-link></friendly-link>
        <Footer></Footer>
      </el-footer>
      <div class="up-top" v-show="upShow">
        <div class="top" @click="top">
          <i class="el-icon-arrow-up"></i>
        </div>
      </div>
      <!--  机器人图标-->
      <el-badge id="smart" v-drag @click.native="smart"> </el-badge>
      <!-- 机器人会话弹窗 -->
      <!-- <chat-robot v-if="isShow" @chat_close="smart_close"></chat-robot> -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from '../components/common/Header.vue'
import BaseHeader from '../components/common/BaseHeader.vue'
import NavMenu from '../components/common/NavMenu.vue'
import Footer from '../components/common/Footer.vue'
import FriendlyLink from '../components/front/FriendlyLink.vue'
import Partner from '../components/front/Partner.vue'
// import ChatRobot from './robot/aiChat'

const HEIGHT =
  document.body.clientHeight || document.documentElement.clientHeight
const WIDTH = document.body.clientWidth || document.documentElement.clientWidth
export default {
  components: {
    Header,
    BaseHeader,
    NavMenu,
    Footer,
    FriendlyLink,
    Partner
    // ChatRobot
  },
  data() {
    return {
      up: true,
      style: {
        'min-width': '1180px',
        width: WIDTH + 'px',
        height: HEIGHT + 'px'
      },
      isShow: false,
      isShowQuestion: false
    }
  },
  computed: {
    getKeepAliveList() {
      return []
    },
    upShow() {
      return this.up
    }
  },
  created() {
    this.upToken()
    this.getLoginStatus()
    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll)
    }, 500)
  },
  methods: {
    ...mapActions(['upToken', 'getLoginStatus']),
    smart(e) {
      console.log(e)
      // if (e.target.getAttribute('data-flag') === 'true') {
      //   this.isShow = true
      // }
      // alert('111')
      // this.$router.push({
      //   name: 'chatRobot'
      // })
      window.open('/aiChat')
      // this.isShowQuestion = false
    },
    smart_close() {
      this.isShow = false
    },
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      if (top > 200) {
        this.up = true
      } else {
        this.up = false
      }
    },
    top() {
      window.scrollTo(0, 0)
    }
  },
  watch: {
    up(newValue, oldValue) {
      // console.log('uposhow---', newValue, oldValue);
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
#smart {
    width: 73px;
    height: 100px;
    border-radius: 23px;
    position: fixed;
    left: 94%;
    bottom: 16%;
    z-index: 2001;
    background: url('~@/components/chatRobot/image/robot.png');
    background-size: 100% 100%;
    &::before{
      content: '智能助手';
      width 50px;
      font-size: 12px;
      color:#333;
      position absolute;
      transform:translateX(-50%)
      left:50%;
      top:-5px;
    }
  }
.head {
    flex-y(flex-start);
    position: relative;
}

.nav-wrap {
    width: 100%;
    background: #005FD9;
    height: 43.2px;
    flex-x(center);
}

.el-main {
    padding: 0;
    width: 100%;
}

.el-header {
    padding: 0;
}

>>>.el-footer {
    height: auto !important;
    padding: 0;
    margin-top: 12px;
}

.up-top {
    width: 48px;
    flex-y(center);
    color: white;
    position: fixed;
    left: 95%;
    bottom: 10%;
    z-index: 100;
    font-size: 25px;

    .top {
        width: 48px;
        height: 48px;
        flex-center();
        box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
        border-radius: 4px;
        background: #d9d9d9;
    }

    .star {
        background: white;
        margin-bottom: 8px;
        color: #5b5b5b;
        border: 1px #d9d9d9 dashed;
    }

    .el-icon-star-on {
        color: blue;
    }

    div:hover {
        cursor: pointer;
    }
}

>>>.el-dialog__header {
    flex-x(space-between);

    .dialog-title {
        font-size: 16px;
        color: gray3;
        line-height: 21px;
        text-align: left;
        width: 90%;
        ellipsis();
    }
}

.dialog-contianer {
    padding: 24px 0;
    flex-y();

    .dialog-amount {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin-top: 20px;
        font-weight: 500;

        span {
            color: rgba(255, 87, 31, 1);
        }
    }

    .dialog-btn {
        flex-x();
        margin: 40px 0;

        svg {
            width: 16px;
            height: 16px;
            margin-right: 12px;
        }
    }

    .share-code {
        flex-y(center, flex-start);

        p {
            color: #197DFF;
            padding-bottom: 15px;
        }
    }
}
</style>
